import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.dispatch("connect")
  }

  scroll() {
    this.element.scrollIntoView()
  }
}
